import React, { useContext, useState, useEffect } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Typography from '@visa/vds/typography';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Select from '@visa/vds/select';
import { PageHelper } from '../../../_helpers/PageHelper';
import { adminService } from '../../../services/admin.service';
import { userService } from '../../../services/user.service';
import FeeWaiver from './Components/FeeWaiverTable';
import { GlobalAlertContext } from '../../../context/GlobalAlertContext';
import { SubscriptionApi } from 'services/subscription.service';
import { UserRole } from '_constants/UserRole';
import FaqA from './Faq/FaqA';

function ManageFeeWaiver() {
  const [feeWaivers, setFeeWaivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getFeeWaiver = async () => {
    setLoading(true);
    setError(null);

    let isMounted = true;

    try {
      const res = await SubscriptionApi.GetFeeWaiver();
      const items = Array.isArray(res?.data?.items) ? res.data.items : [];
      if (isMounted) setFeeWaivers(items);
    } catch (e) {
      if (isMounted) setError('Failed to load fee waivers.');
    } finally {
      if (isMounted) setLoading(false);
    }

    return () => { isMounted = false; };
  };

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await SubscriptionApi.GetFeeWaiver();
        if (cancelled) return;
        const items = Array.isArray(res?.data?.items) ? res.data.items : [];
        setFeeWaivers(items);
      } catch {
        if (!cancelled) setError('Failed to load fee waivers.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return (
    <GlobalAlertContext.Consumer>
      {alertObj => (
        <>
          <Grid>
            <Row>
              <Col>
                <Typography tag="h1">Manage Fee Waivers/Fee Discounts</Typography>
              </Col>
            </Row>

            {error && (
              <Row>
                <Col>
                  <Typography tag="p" style={{ color: 'red' }}>
                    {error}
                  </Typography>
                </Col>
              </Row>
            )}

            <Row>
              <FeeWaiver
                fetched={!loading}
                feeWaivers={feeWaivers}
              />
            </Row>
          </Grid>
        </>
      )}
    </GlobalAlertContext.Consumer>
  );
}

export default ManageFeeWaiver;
